import React, { useRef } from "react";
import PeranKementerianCard from "@/app/Components/PeranKementerianCard";
import { motion, useScroll } from "framer-motion";

const PeranKementerian = () => {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start 0", "end 1"],
  });

  const dataDummy = [
    {
      title: "ASTA CITA 2",
      description:
        "Memantapkan sistem pertahanan kemanan negara dan mendorong kemandirian bangsa melalui swasembada pangan, energi, air, <span class='font-bold'> ekonomi syariah, ekonomi digital, ekonomi hijau, dan ekonomi biru.</span>",
      image: "/image/PeranKementerian1.webp",
    },
    {
      title: "ASTA CITA 3",
      description:
        "Melanjutkan pengembangan infrastruktur dan <span class='font-bold'>meningkatkan lapangan kerja yang berkualitas, mendorong kewirausahaan, mengembangkan industri kreatif</span> serta mengembangkan agromaritim industri di sentra produksi melalui peran aktif koperasi.",
      image: "/image/PeranKementerian2.webp",
    },
    {
      title: "ASTA CITA 4",
      description:
        "<span class='font-bold'>Memperkuat Pembangunan SDM</span>, sains, teknologi, Pendidikan, Kesehatan, prestasi olahraga, kesetaraan gender, serta penguatan peran Perempuan, pemuda (Generasi milenial dan generasi Z), dan penyandang disabilitas.",
      image: "/image/PeranKementerian3.webp",
    },
    {
      title: "ASTA CITA 6",
      description:
        "<span class='font-bold'>Membangun dari desa</span> dan dari bawah untuk pertumbuhan ekonomi, pemerataan ekonomi, dan pemberantasan kemiskinan.",
      image: "/image/PeranKementerian4.webp",
    },
    {
      title: "ASTA CITA 7",
      description:
        "Memperkuat reformasi politik, hukum, dan birokrasi serta memperkuat pencegahan dan pemberantasan korupsi, narkoba, judi dan penyelundupan.",
      image: "/image/PeranKementerian5.webp",
    },
  ];

  return (
    <div ref={sectionRef} className="relative h-[300vh]">
      {/* <div className="absolute flex flex-col w-full h-full">
        <div id={0} className="h-screen w-full bg-red-500" />
        <div id={1} className="h-screen w-full bg-green-500" />
        <div id={2} className="h-screen w-full bg-blue-500" />
      </div> */}
      <div
        className="sticky top-0 flex flex-col justify-center items-center w-full min-h-screen overflow-hidden gap-5 md:gap-7 px-5 md:px-10 lg:px-16 pt-5 pb-20
      bg-[url('/image/bg-peran-kementerian.webp')] 
      text-white bg-cover bg-center bg-no-repeat"
      >
        <div className="absolute inset-0 bg-[#1E1D1DDE]" />
        <motion.div
          className="text-2xl sm:text-4xl lg:text-5xl text-center lg:text-left font-bold w-full z-10"
          initial={{
            opacity: 0,
            x: 100,
          }}
          whileInView={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            delay: 1,
          }}
          viewport={{ once: true }}
        >
          Peran Kementerian UMKM
        </motion.div>
        <div className="w-full h-full">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 w-full z-10 gap-5">
            {dataDummy.map((data, index) => (
              <PeranKementerianCard
                key={index}
                data={data}
                index={index}
                length={dataDummy.length}
                scrollYProgress={scrollYProgress}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeranKementerian;
